import(/* webpackMode: "eager" */ "/opt/build/repo/app/projects/page.tsx");
